<div class="breadcrumb-wrapper">
    <div *ngFor="let breadcrumbItem of breadcrumbs; let lastItem = last">
        <div *ngIf="lastItem"><b>{{breadcrumbItem.label}}</b></div>
        <div *ngIf="!lastItem" class="not-last-item">
            <a [routerLink]="[breadcrumbItem.url === '' ? '/admin' : '/admin' + breadcrumbItem.url]">{{breadcrumbItem.label}}</a>
            <mat-icon *ngIf="breadcrumbs.length > 1">chevron_right</mat-icon>
        </div>
    </div>
</div>